/**
 * Combined localization dropdown for AIR TEAM header.
 * Supports one-click profiles (country + locale).
 * Vendor Maranello LocalizationForm only supports one hidden field — this element supports both.
 */
class AtmLocalizationForm extends HTMLElement {
  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this.button = this.querySelector('button.dropdown-toggle');
    this.panel = this.querySelector('.dropdown-list-wrap');

    if (!this.button || !this.panel) return;

    this.button.addEventListener('click', this.toggleSelector.bind(this));
    this.button.addEventListener('focusout', this.closeSelector.bind(this));
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

    this.querySelectorAll('[data-type="profile"]').forEach((item) => {
      // mousedown/pointerdown before focusout — prevents panel close race that submits stale CZ/cs
      item.addEventListener('pointerdown', this.onItemPointerDown.bind(this));
      item.addEventListener('click', this.onItemClick.bind(this));
    });
  }

  hidePanel() {
    this.button.blur();
    this.button.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('aria-hidden', 'true');
  }

  isOpen() {
    return this.panel.getAttribute('aria-hidden') === 'false';
  }

  toggleSelector(event) {
    event.preventDefault();
    if (this.isOpen()) {
      this.hidePanel();
      return;
    }
    this.button.focus();
    this.panel.setAttribute('aria-hidden', 'false');
    this.button.setAttribute('aria-expanded', 'true');
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    this.hidePanel();
    this.button.focus();
  }

  onItemPointerDown(event) {
    if (event.button != null && event.button !== 0) return;
    event.preventDefault();
    this.submitProfile(event.currentTarget);
  }

  onItemClick(event) {
    event.preventDefault();
    // pointerdown already submitted; guard double-submit
    if (this._submitting) return;
    this.submitProfile(event.currentTarget);
  }

  submitProfile(link) {
    if (!link || this._submitting) return;

    const country = link.dataset.country;
    const locale = link.dataset.locale;
    const form = this.querySelector('form');
    const lockCountry = this.dataset.lockCountry === 'true';

    if (!form || !locale) return;
    if (!lockCountry && !country) return;

    const countryInput = form.querySelector('input[name="country_code"]');
    const localeInput = form.querySelector('input[name="locale_code"]');

    if (!countryInput || !localeInput) return;

    localeInput.value = locale;
    // Logged-in buyers: company address drives market/catalog/currency — locale only.
    if (!lockCountry) {
      countryInput.value = country;
    }
    this._submitting = true;
    form.submit();
  }

  closeSelector(event) {
    const related = event.relatedTarget;
    if (related && this.contains(related)) return;

    requestAnimationFrame(() => {
      if (this._submitting) return;
      if (this.contains(document.activeElement)) return;
      this.hidePanel();
    });
  }
}

customElements.define('atm-localization-form', AtmLocalizationForm);
